import { useTheme } from '../../context/ThemeContext';

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      onClick={toggleTheme}
      className="relative inline-flex h-7 w-12 items-center rounded-full
        transition-colors duration-200 focus:outline-none
        focus-visible:ring-2 focus-visible:ring-[#0078d4] focus-visible:ring-offset-2
        focus-visible:ring-offset-[var(--header-bg)]"
      style={{ backgroundColor: isDark ? '#273344' : '#0078d4' }}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      <span
        className={`inline-flex h-5 w-5 items-center justify-center rounded-full
          shadow-sm transition-transform duration-200
          ${isDark ? 'translate-x-1' : 'translate-x-6'}`}
        style={{ backgroundColor: isDark ? '#58a6ff' : '#ffffff' }}
      >
        <span
          className="material-symbols-outlined text-[13px]"
          style={{ color: isDark ? '#0d1117' : '#0056b3' }}
          aria-hidden="true"
        >
          {isDark ? 'dark_mode' : 'light_mode'}
        </span>
      </span>
    </button>
  );
}
